module.exports = __webpack_public_path__ + "img/25.457b32cf.webp";